import React, { ReactNode } from 'react';
import { styled } from 'styled-components';

import checkSquareIcon from '../../assets/icons/icon_mobile-check-square.svg';

interface StyledCheckBoxContainerStyle {
  $margin?: string;
  $alignSelf?: string;
  $justifySelf?: string;
}
export const StyledCheckBoxContainer = styled.label<StyledCheckBoxContainerStyle>`
  align-self: ${p => p.$alignSelf ?? 'auto'};
  justify-self: ${p => p.$justifySelf ?? 'auto'};
  margin: ${p => p.$margin ?? 'unset'};
`;

export const SectionCheckbox = styled.input.attrs({ type: 'checkbox' })`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
  appearance: none;
  background: #ffffff;
  border: 1px solid #2e5be0;
  box-shadow: 0px 6px 9px -5px rgba(186, 186, 186, 0.15);
  border-radius: 2px;
  cursor: pointer;

  &:checked {
    border-color: transparent;
    background-image: url(${checkSquareIcon});
    background-size: 16px 16px;
    background-position: 50%;
    background-repeat: no-repeat;
    background-color: #ffffff;
  }

  &:disabled {
    background-color: #e8e8e8;
    border: 1px solid #bdbdbd;
    cursor: not-allowed;
  }
`;

export interface CheckboxWithTextProps extends StyledCheckBoxContainerStyle {
  text?: ReactNode;
  value?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
}
export const CheckboxWithText = ({
  text,
  value,
  onChange,
  disabled,
  ...containerStyle
}: CheckboxWithTextProps) => {
  return (
    <StyledCheckBoxContainer {...containerStyle}>
      <SectionCheckbox
        disabled={disabled}
        checked={value}
        onChange={e => onChange?.(e.target.checked)}
      />
      {text}
    </StyledCheckBoxContainer>
  );
};

export const MobileCheckbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 10px;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  appearance: none;
  background: #ffffff;
  border: 1.5px solid #2e5be0;
  box-sizing: border-box;
  border-radius: 2px;
  cursor: pointer;

  &:checked {
    border-color: transparent;
    background-image: url(${checkSquareIcon});
    background-size: 20px 20px;
    background-position: 50%;
    background-repeat: no-repeat;
    background-color: #ffffff;
  }

  &:disabled {
    border-color: darkgray;
    cursor: not-allowed;
  }
`;

export const CheckboxText = styled.span`
  font-size: 14px;
  color: var(--HScan_left_menu_grey, #666973);
`;

export const MobileCheckboxWithText = ({
  text,
  value,
  onChange,
  disabled,
  ...containerStyle
}: CheckboxWithTextProps) => {
  return (
    <StyledCheckBoxContainer {...containerStyle}>
      <MobileCheckbox
        disabled={disabled}
        checked={value}
        onChange={e => onChange?.(e.target.checked)}
      />
      <CheckboxText>{text}</CheckboxText>
    </StyledCheckBoxContainer>
  );
};
